import { List } from "components";
import CreateItemButton from "components/buttons/create";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useJob } from "../context";
import { RenderProfile } from "components/render-profile";
import { getUserFields } from "components/user/config";
import HeaderPortal from "components/portal/header-portal"

export default function JobsEmployees() {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const { type, department, isDepartmentRequired } = useJob();

  const fields = [
    "id",
    "is_logging_restricted",
    "is_shadow",
    getUserFields("employee"),
    getUserFields("reviewer")
  ];
  const columns = [
    {
      id: "employee.id",
      header: "Name",
      accessorKey: "employee",
      cell: ({ getValue }) => {
        return <RenderProfile user={getValue()} />;
      },
    },
    {
      id: "employee.grade.name",
      header: "Grade",
      accessorKey: "employee.grade.name",
      sortable: false,
    },
    {
      id: "employee.department.name",
      header: "Department",
      accessorKey: "employee.department.name",
    },
    {
      id: "employee.reviewer",
      header: "Reviewer",
      accessorKey: "reviewer",
      cell: ({ getValue }) => {
        return <RenderProfile user={getValue()} />;
      },
    },
    {
      id: "is_logging_restricted",
      header: "Logging",
      accessorKey: "is_logging_restricted",
      cell: ({ getValue }) => {
        const isRestricted = getValue();
        return <span>{isRestricted ? "Restricted" : "Allowed"}</span>;
      },
      sortable: false,
    },
    ...(type === "dedicated"
      ? [
        {
          id: "is_shadow",
          header: "Is Shadow?",
          accessorKey: "is_shadow",
          cell: ({ getValue }) => {
            const isShadow = getValue();
            return <span>{isShadow ? "Yes" : "No"}</span>;
          },
          sortable: false,
        },
      ]
      : []),

  ];

  const defaultFilters = {
    job: {
      _eq: jobId,
    },
  };

  return (
    <div className="p-2 flex-1 overflow-auto">
      <HeaderPortal>
        <PermissionGate
          rule="create:PC,SC,JC,AM"
          collection="jobs_employees"
          showWhenDisabled={false}
        >
          <CreateItemButton
            disabled={isDepartmentRequired && !department?.length}
            onClick={() => navigate("+")}
          >
            Employees
          </CreateItemButton>
        </PermissionGate>
      </HeaderPortal>

      <List
        title="Employees"
        storageKey={jobId}
        endPoint="jobs_employees"
        href={(item) => `${item.id}/edit`}
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        perPage={25}
        hidePagination={true}
        showSearch={false}
        emptySectionTitle={
          isDepartmentRequired && department?.length === 0
            ? `Add budget to assign employees`
            : `No Entry found`
        }
        emptySectionDescription={
          isDepartmentRequired &&
          department?.length === 0 &&
          `Please ask the Finance team to add the Budget first. You’ll only be able to add employees whose departments are already included in the budget. Once that's done, you can proceed to add employees accordingly.`
        }
        emptySectionDescriptionVariant={"alert"}
      />
    </div>
  );
}
